'use client';

import { c as _c } from "react/compiler-runtime";
import ReceiveAuthBC from '@module/helpers/broadcast/ReceiveAuthBC';
import { cn } from '@module/lib/utils';
import CustomerNav from './_components/customer/CustomerNav';
import MainSearchInput from './_components/search/MainSearchInput';
import TopNavLogo from './_components/TopNavLogo';
import TopNavRightControls from './_components/TopNavRightControls';
function TopNavContainer(t0) {
  const $ = _c(27);
  const {
    onlyLogo,
    isCustomerPage,
    hideSearchInput,
    narrow,
    openNewWindow
  } = t0;
  const stabilizeMyNav = hideSearchInput && !onlyLogo && !isCustomerPage;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("fixed top-0 left-0 z-[31] h-[63px] w-full border-r-1 border-b bg-colorBg14 shadow-top-nav");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== stabilizeMyNav) {
    t2 = !stabilizeMyNav && <ReceiveAuthBC />;
    $[1] = stabilizeMyNav;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== narrow) {
    t3 = cn("relative m-auto flex h-full w-full items-center justify-between px-6", {
      "max-w-[1360px] px-10": narrow
    });
    $[3] = narrow;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== openNewWindow) {
    t4 = <TopNavLogo openNewWindow={openNewWindow} />;
    $[5] = openNewWindow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isCustomerPage) {
    t5 = isCustomerPage && <h5 className="ml-2.5 text-nowrap font-semibold text-[18px] text-colorFg02">고객센터</h5>;
    $[7] = isCustomerPage;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-nowrap items-center gap-[30px]"><div className="relative z-10 flex flex-nowrap items-center">{t4}{t5}</div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isCustomerPage) {
    t7 = isCustomerPage && <CustomerNav />;
    $[12] = isCustomerPage;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hideSearchInput || $[15] !== isCustomerPage || $[16] !== onlyLogo || $[17] !== stabilizeMyNav) {
    t8 = !onlyLogo && <>{!hideSearchInput && <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"><MainSearchInput /></div>}<TopNavRightControls deferUntilMounted={stabilizeMyNav} isCustomerPage={isCustomerPage} /></>;
    $[14] = hideSearchInput;
    $[15] = isCustomerPage;
    $[16] = onlyLogo;
    $[17] = stabilizeMyNav;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <nav className={t3}>{t6}{t7}{t8}</nav>;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t9) {
    t10 = <div id="top-nav-container" data-testid="top-nav" className={t1}>{t2}{t9}</div>;
    $[24] = t2;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
export default TopNavContainer;